import Flickity from 'flickity';

function initPageGallery(pageGallery) {
  const flkty = new Flickity(pageGallery, {
    cellSelector: '.page-gallery__slide',
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true
  });

  const prevButton = pageGallery.querySelector('.page-gallery__button.previous');
  const nextButton = pageGallery.querySelector('.page-gallery__button.next');

  prevButton.addEventListener('click', () => {
    flkty.previous();
  });
  nextButton.addEventListener('click', () => {
    flkty.next();
  });
};

export default initPageGallery;